<template>
  <div class="action-plan-form">
    <div class="container-fluid">
      <div class="row mb-3 no-print">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <p class="lead m-0">Plano de Ação</p>
          </div>
        </div>
      </div>

      <div>
        <Filter @filter="onFilter" @print="onPrint" ref="filter" />
      </div>

      <div class="row mt-3 cards">
        <div class="col-12">
          <div class="container">
            <div class="card">
              <div class="card-body loadable">
                <div class="container-fluid" v-if="!loading1">
                  <div class="row">
                    <div class="col-12 card-title">Riscos do levantamento</div>
                  </div>
                  <div class="row">
                    <div
                      v-if="chartReady"
                      class="
                        col-9
                        chart-col
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <apexchart
                        type="pie"
                        width="500"
                        :options="chartOptions"
                        :series="series"
                      ></apexchart>
                    </div>
                    <div class="col-3 loading-info" v-if="loading">
                      Carregando informações...
                    </div>
                    <div class="col-3" v-else>
                      <table class="w-100">
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in general_statement.confined_spaces_risk_status"
                            :key="index"
                          >
                            <td class="d-flex align-items-center">
                              <div
                                class="round-circle"
                                :style="{
                                  'background-color': item.color,
                                }"
                              ></div>
                              <div class="risk-description">
                                {{ item.name }}
                              </div>
                            </td>
                            <td class="risk-description text-right">{{ item.result }}</td>
                          </tr>
                          <tr style="height: 47px">
                            <td class="risk-description">Total:</td>
                            <td class="risk-description text-right">
                              {{ general_statement.total_situations }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-4">
                      <div class="statement-description">
                        E.C.s levantados:
                        {{ general_statement.total_confined_spaces }}
                      </div>
                      <div class="statement-description">
                        E.C.s não conformes:
                        {{ general_statement.total_confined_spaces }}
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="statement-description">
                        Não conformidades:
                        {{ general_statement.total_noncompliances }}
                      </div>
                      <div class="statement-description">
                        Itens em desacordo NR-33:
                        {{ general_statement.total_noncompliances }}
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="statement-description">
                        Multa prevista:
                        R${{ formatPrice(general_statement.total_max_fine) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="loading-panel" v-if="loading1">
                  <ProgressSpinner />
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body loadable">
                <div class="container-fluid" v-if="!loading2">
                  <div class="row">
                    <div class="col-12 card-title">Riscos atuais</div>
                  </div>
                  <div class="row" v-if="chartReady2">
                    <div
                      class="
                        col-9
                        chart-col
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <apexchart
                        type="pie"
                        width="500"
                        :options="chartOptions2"
                        :series="series2"
                      ></apexchart>
                    </div>
                    <div class="col-5 loading-info" v-if="loading2">
                      Carregando informações...
                    </div>
                    <div class="col-3" v-if="!loading2">
                      <table class="w-100">
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in general_statement_current.confined_spaces_risk_status"
                            :key="index"
                          >
                            <td class="d-flex align-items-center">
                              <div
                                class="round-circle"
                                :style="{
                                  'background-color': item.color,
                                }"
                              ></div>
                              <div class="risk-description">
                                {{ item.name }}
                              </div>
                            </td>
                            <td class="risk-description text-right">{{ item.result }}</td>
                          </tr>
                          <tr style="height: 47px">
                            <td class="risk-description">Total:</td>
                            <td class="risk-description text-right">
                              {{ general_statement_current.total_situations }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="loading-panel" v-if="loading2">
                  <ProgressSpinner />
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body loadable">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12 card-title">
                      Plano de Ação Ambra por Etapas
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-12">
                      <phases :filters="filters" v-bind:step="parseInt(step)" ref="phases"></phases>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="paginator" v-if="totalRecords > perPage">
        <Paginator
          :first="(currentPage - 1) * perPage"
          :rows="perPage"
          :total-records="totalRecords"
          @page="onPage($event)"
        ></Paginator>
      </div>

      <div
        class="form-item-holder mb-3"
        v-for="(item, i) in riskAnalyses"
        :key="item.id"
      >
        <form-item
          ref="uploaded-items"
          :risk-analysis="item"
          :work-fronts="work_fronts"
          :index="(currentPage - 1) * perPage + i + 1"
          :filters="fullQueryString"
          :isPrinting="isPrinting"
        ></form-item>
        <div class="loading-panel" v-if="loading">
          <ProgressSpinner />
        </div>
      </div>

      <div class="no-items" v-if="!riskAnalyses || riskAnalyses.length === 0">
        Nenhuma não conformidade encontrada para esta fase
      </div>

      <div class="paginator" v-if="totalRecords > perPage">
        <Paginator
          :first="(currentPage - 1) * perPage"
          :rows="perPage"
          :total-records="totalRecords"
          @page="onPage($event)"
        ></Paginator>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed } from '@vue/runtime-core'
  import { useRoute } from 'vue-router'

  import useWorkFront from '@/modules/WorkFront'

  import FormItem from './components/FormItem'
  import { useStore } from 'vuex'

  import Paginator from 'primevue/paginator'
  import ProgressSpinner from 'primevue/progressspinner'

  import Phases from './components/Phases'
  import Filter from '@/components/confined_space/Filter.vue'

  export default {
    setup() {
      const store = useStore()
      const { params } = useRoute()
      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
      const { step } = params

      const { listAllWorkFronts, work_fronts } = useWorkFront()

      listAllWorkFronts(selected_company.value?.id)

      return {
        selected_company,
        selected_order_of_service,
        step,
        params,
        work_fronts,
      }
    },
    components: {
      FormItem,
      Paginator,
      ProgressSpinner,
      Filter,
      Phases,
    },
    data() {
      return {
        riskAnalyses: [],
        filters: {},
        perPage: 10,
        currentPage: 1,
        totalRecords: null,
        lastPage: null,
        loading: false,
        queryString: '',
        fullQueryString: '',
        loading1: false,
        loading2: false,
        chartReady: false,
        chartReady2: false,
        general_statement: {},
        general_statement_current: {},
        series: [],
        series2: [],
        chartOptions: {
          chart: {
            width: 500,
            type: 'pie',
          },
          labels: [],
          colors: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          }],
          legend: {
            show: false,
          },
        },
        chartOptions2: {
          chart: {
            width: 500,
            type: 'pie',
          },
          labels: [],
          colors: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          }],
          legend: {
            show: false,
          }
        },
        isPrinting: false,
      }
    },
    mounted() {
      if (this.params?.filters) {
        this.filters = JSON.parse(this.params?.filters)
        
        if (this.filters.confinedSpaceId) {
          this.filters.confined_space_id = this.filters.confinedSpaceId
          this.$refs.filter.setConfinedSpaceId(this.filters.confined_space_id)
        }
      }

      this.loadData()
      this.loadDataCard1()
      this.loadDataCard2()
      this.$refs.phases.onFilter(this.filters)
    },
    methods: {
      loadData(page) {
        const app = this
        page = page || 1

        this.loading = true

        this.queryString = this.getQueryString(page, this.perPage)

        if (this.step) this.queryString += `&phase=${this.step}`

        this.fullQueryString = 'order_of_service_id=' + this.selected_order_of_service.id + this.queryString

        this.axios
          .get(
            `/api/action-plan/get-by-phase/?&confined_space=1&order_of_service_id=${this.selected_order_of_service.id}${this.queryString}`,
          )
          .then(({ data }) => {
            app.riskAnalyses = data.data
            app.totalRecords = data.total
            app.lastPage = data.last_page
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => (this.loading = false))
      },

      loadDataCard1() {
        const app = this
        app.loading1 = true

        let queryString = this.getQueryString()

        if (this.step) queryString += `&phase=${this.step}`

        if (this.selected_order_of_service.id) {
          this.reload = false
          this.series = []
          this.chartOptions.labels = []
          this.chartOptions.colors = []

          app.axios
            .get(
              `/api/orders_of_service/actionPlanStatementConfinedSpace?order_of_service_id=${this.selected_order_of_service.id}${queryString}`,
            )
            .then(({ data }) => {
              this.general_statement = data
              this.mountChart1()
            })
            .catch((error) => {
              //console.log(error)
            })
            .finally(() => {
              app.loading1 = false
              this.reload = true
            })
        }
      },

      mountChart1() {
        this.general_statement.confined_spaces_risk_status.forEach(el => {
          this.series.push(el.result)
          this.chartOptions.labels.push(el.name)
          this.chartOptions.colors.push(el.color)
        })

        this.chartReady = true
      },

      loadDataCard2() {
        const app = this
        app.loading2 = true

        let queryString = this.getQueryString()

        if (this.step) queryString += `&phase=${this.step}`
        
        if (this.selected_order_of_service.id) {
          this.reload2 = false

          this.series2 = []
          this.chartOptions2.labels = []
          this.chartOptions2.colors = []

          app.axios
            .get(
              `/api/orders_of_service/actionPlanStatementCurrentConfinedSpace?order_of_service_id=${this.selected_order_of_service.id}${queryString}`,
            )
            .then(({ data }) => {
              this.general_statement_current = data
              this.mountChart2(this.general_statement_current)
            })
            .catch((error) => {
              //console.log(error)
            })
            .finally(() => {
              app.loading2 = false
              this.reload2 = true
            })
        }
      },

      mountChart2() {
        this.general_statement_current.confined_spaces_risk_status.forEach((el) => {
          this.series2.push(el.result)
          this.chartOptions2.labels.push(el.name)
          this.chartOptions2.colors.push(el.color)
        })

        this.chartReady2 = true
      },

      getQueryString(page, perPage) {
        let query = ''

        if (page) query += `&page=${page}`

        if (perPage) query += `&perPage=${perPage}`

        if (this.filters) {
          const queryStringFilters = Object.keys(this.filters)
            .filter((key) => this.filters[key])
            .map((key) => key + '=' + this.filters[key])
            .join('&')

          query += `&${queryStringFilters}`
        }

        return query
      },

      onPage(event) {
        const page = event.page + 1
        this.currentPage = page

        this.loadData(page)
      },

      onFilter(event) {
        this.filters = event

        this.loadData(this.currentPage)
        this.loadDataCard1()
        this.loadDataCard2()
        this.$refs.phases.onFilter(this.filters)
      },

      onPrint(event) {
        this.isPrinting = event
      },
      
      formatPrice(value) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    },
    watch: {
      selected_order_of_service() {
        this.loadDataCard1()
        this.loadDataCard2()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .action-plan-form {
    .form-item-holder {
      position: relative;

      @media print {
        margin-top: 10px;
        break-inside: avoid;
        page-break-after: always;
      }

      .loading-panel {
        position: absolute;
        top: 0;
        left: 0;

        height: 100%;
        width: 100%;

        background-color: #e9ecef;

        display: flex;
        align-items: center;
        justify-content: center;

        opacity: 0.9;
      }
    }
  }

  .cards {
    visibility: hidden;
    position: absolute;
    bottom: 0;

    @media print {
      visibility: visible;
      position: static;
    }
  }

  .card {
    margin-bottom: 100px;
    min-height: 400px;

    @media print {
      page-break-after: always;
      break-inside: avoid;
    }
  }
  .card-title {
    text-align: center;
    font-weight: 500;
    font-size: 32px;
    color: #7e7e7e;
    margin-bottom: 25px;
  }
  .statement-description,
  .risk-description {
    font-weight: 500;
    font-size: 20px;
    color: #7e7e7e;
  }
  .round-circle {
    color: black;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    margin-right: 10px;
  }
  table {
    tr {
      border-bottom: 1px solid rgb(165, 165, 165);
    }
    td {
      margin-bottom: 7px;
      margin-top: 7px;
    }
  }
  .chart-col {
    margin-top: 50px;
  }
  .loading-info {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    color: #7e7e7e;
  }

  .loadable {
    position: relative;

    .loading-panel {
      position: absolute;
      top: 0;
      left: 0;

      height: 100%;
      width: 100%;

      background-color: #e9ecef;

      display: flex;
      align-items: center;
      justify-content: center;

      opacity: 0.9;
    }
  }
</style>
